import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { AuthService } from "app/core/auth/auth.service";
import { of, switchMap } from "rxjs";

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const authService = inject(AuthService);

  // Check the authentication status
  return authService.check().pipe(
    switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Redirect to the sign-in page with a redirectUrl param
        const accessDeniedMessage = authService.accessDeniedMessage;
        const urlTree = router.createUrlTree(["/sign-in"], {
          queryParams: {
            ...(state.url === "/sign-out" ? {} : { redirectURL: state.url }),
            ...(accessDeniedMessage
              ? {
                  error: "access_denied",
                  message: accessDeniedMessage,
                }
              : {}),
          },
        });

        return of(urlTree);
      }

      // Allow the access
      return of(true);
    }),
  );
};
